import '@babel/polyfill'
import 'objectFitPolyfill'
import $ from 'jquery'
import PerfectScrollbar from 'perfect-scrollbar'
import Jump from 'jump.js'
import ScrollOut from 'scroll-out'
import ScrollHint from 'scroll-hint'
import './lib/shadowbox.js';

import G_header from './components/global_header'
import Global_follow from './components/global_follow'
import Top from './components/top'
import Page_active from './components/pages_active'
import Page_scroll from './components/page_scroll'
import Device_replace from './components/device_replace'
import Accodion from './components/acco'
import AppModal from './components/modal'
import Top_smooth from './components/global_smooth'
import Tab from './components/tab'
const global_smooth = new Top_smooth()
const global_header = new G_header($)
const global_follow = new Global_follow($)
const global_device_replace = new Device_replace()
const app_Page_scroll = new Page_scroll($)
const app_Page_active = new Page_active($)
const app_Top = new Top($)
const app_acco = new Accodion()
const app_modal = new AppModal('.closebtn', '.btn-modal', $)
const app_tab = new Tab('[data-tab]')

import Swiper from 'swiper/js/swiper.js'
import Top_swiper from './components/top_swiper'

let timeout: null | any
let flag: boolean

const checkWith = (...testcheck: any) => {
  let w = window.innerWidth
  if (timeout) return
  timeout = setTimeout(function() {
    timeout = null
    if (w <= 501 && flag != false) {
      flag = false
      testcheck[0]()
    } else if (w > 500 && flag != true) {
      flag = true
      testcheck[0]()
    }
  }, 0)
}

window.addEventListener('orientationchange', function() {
  let orient: any = window.orientation
  location.reload(true)
  if (Math.abs(orient) === 90) {
    location.reload(true)
  }
})

declare var Shadowbox: any;

document.addEventListener('DOMContentLoaded', function() {
Shadowbox.init({overlayOpacity: 0.75});

  const wrapper = document.getElementsByClassName('wrapper')[0]
  const data_set = wrapper.getAttribute('data-slider')
  const top_swiper = new Top_swiper(Swiper)
  if (data_set) {
    if (data_set === 'top') {
      top_swiper.main()
    }
  }

  ScrollOut({
    once: true
  })
  new ScrollHint('.js-scrollable')
  new PerfectScrollbar('#scrollarea')

  const Location = location.pathname
  const arr_location = Location.split('/')
  const x = arr_location.filter(function(v) {
    return v
  })

  app_acco.acco($)
  app_Page_scroll.is_page_scroll()
  app_Page_active.activeFunc(x)
  app_modal.Main()
  app_tab.main()
  global_smooth.smooth(Jump)

  app_Top.aloneFunc()
  global_follow.main()
  global_device_replace.main()

  const clickEvent_target = document.querySelectorAll('.js-drop-nav')
  const array = Array.prototype.slice.call(clickEvent_target)
  const array_len = array.length

  const menuTrigger: HTMLElement | null = document.getElementById('menuTrigger')
  const def_acco = $('.def_acco')
  let globalFunc = function() {
    const breakpoint = 501
    if (window.innerWidth <= breakpoint) {
      menuTrigger!.addEventListener(
        'click',
        function(e: any) {
          e.preventDefault()
          global_header.global_spHeader_fun()
        },
        false
      )

      def_acco.on('click', function(this: string, e: any) {
        e.preventDefault()
        if ($(this).hasClass('toggle')) {
          $(this).removeClass('toggle')
          $(this)
            .next()
            .stop()
            .slideUp()
        } else {
          $(this).addClass('toggle')
          $(this)
            .next()
            .stop()
            .slideDown()
        }
      })
    } else if (window.innerWidth >= 499) {
      def_acco.off()

      for (let i = 0; i <= array_len - 1; i++) {
        array[i].addEventListener(
          'mouseenter',
          function(this: string) {
            global_header.global_enterfunc(this)
          },
          false
        )

        array[i].addEventListener(
          'mouseleave',
          function(this: string) {
            global_header.global_leavefunc(this)
          },
          false
        )
      }

    }
  }
  global_header.global_follow_header($)

  const anime = function() {
    globalFunc()
  }

  checkWith(anime)

  window.addEventListener('resize', function() {
    checkWith(anime)
  })
})

let startPos = 0,
  winScrollTop = 0
let timeoutId: any
const pageTop = $('.btn_smooth')
window.addEventListener('scroll', function() {
  winScrollTop = $(this).scrollTop()
  if (winScrollTop >= startPos) {
    pageTop.addClass('hide')
  }
  startPos = winScrollTop

  clearTimeout(timeoutId)

  timeoutId = setTimeout(function() {
    pageTop.removeClass('hide')
  }, 200)
})


// もっと見るボタン leaflets_videos //
const moreNum = 5;
$('.seminar-block:nth-child(n + ' + (moreNum + 1) + ')').addClass('is-hidden');
$('.more').on('click', function() {
  $('.seminar-block.is-hidden').slice(0, moreNum).removeClass('is-hidden');
  if ($('.seminar-block.is-hidden').length == 0) {
    $('.more').fadeOut();
    $('.close').fadeIn();
  }
});
$('.close').on('click', function() {
  $('.seminar-block:nth-child(n + ' + (moreNum + 1) + ')').addClass('is-hidden');
  $('.more').fadeIn();
  $('.close').fadeOut();
});